/**
 * @desc 查看环保监测列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.EPMonitorRequest,
): Promise<defs.StandardReturn<Array<defs.EPMonitorListResponse>>> {
  return defHttp.post({
    url: '/web/EPManage/queryEpMonitorList',
    data,
  });
}

export function mock(
  data: defs.EPMonitorRequest,
): Promise<defs.StandardReturn<Array<defs.EPMonitorListResponse>>> {
  return defHttp.post({
    url: '/mock/web/EPManage/queryEpMonitorList',
    data,
  });
}
